









































































































































































































import { Component, Prop, Vue, Inject } from "vue-property-decorator";
import CloseButton from "@/components/buttons/close-button.vue";
import MainDemo from "../../demo/main-demo.vue";
import MenuDemo from "../../demo/menu/menu-demo.vue";
import ChangeDeliteButtons from "../../buttons/change-delite-buttons.vue";
import BSwitch from "../../app/switchs/b-switch.vue";
import LanguagesButtons from "../../../components/buttons/languages-buttons.vue";
import { preferred_language } from "@/config/languags.config.json";

import { IProductCard, ICategory } from "@/@types/menu/menu/menu";
import { AxiosResponse, AxiosError } from "axios";

import axios from "@/api/AuthAPI/auth-request-api";
import { menu } from "@/config/host.config";

@Component({
  components: {
    CloseButton,
    ChangeDeliteButtons,
    MainDemo,
    MenuDemo,
    BSwitch,
    LanguagesButtons,
  },
})
export default class FullcardCard extends Vue {
  @Prop({ type: Object, default: null }) card!: IProductCard;
  @Prop({ type: String, default: "all-menu" }) activeBar!: string;
  @Prop({ type: Boolean, default: true }) showClose!: boolean;
  @Inject({ from: "dishFolder", default: null }) readonly folder!: string;

  productCategory: ICategory | null = null;
  languageDemo = preferred_language;

  get priceText(): string {
    if (!this.card || !this.card.params) return "";
    const parts: Array<string> = [];
    for (const param of this.card.params) {
      if (!param || !param.coast || !param.coast.length) continue;
      const hasName = param.name && Object.keys(param.name).length > 0;
      const prefix = hasName ? `${this.$getLocale(param.name)}: ` : "";
      const coasts = param.coast
        .map((c) => `${c.value} ${this.$currencySymbol(c.currency)}`)
        .join(", ");
      parts.push(prefix + coasts);
    }
    return parts.join("   ");
  }

  changeDelivery(switchToggle: boolean): void {
    this.$parent.$emit("changeDelivery", switchToggle, this.card._id);
  }

  changeAvailability(switchToggle: boolean): void {
    this.$parent.$emit("changeAvailability", switchToggle, this.card._id);
  }

  changeShow(switchToggle: boolean): void {
    this.$parent.$emit("changeShow", switchToggle, this.card._id);
  }

  async getCategoryById(categoryID: string | undefined): Promise<ICategory> {
    const url = menu.categorys + "/" + categoryID;
    return new Promise<ICategory>((res, rej) => {
      axios
        .get(url)
        .then((category: AxiosResponse) => {
          if (category.status === 200) {
            res(category.data);
          }
        })
        .catch((error: AxiosError) => {
          rej(error);
        });
    });
  }

  mounted(): void {
    if (this.card) {
      this.getCategoryById(this.card.category).then((category: ICategory) => {
        this.productCategory = category;
      });
    }
  }
}
